import React from 'react'

import { Drawer } from '@/components/Drawer/DrawerV2'
import DocDraw from './modal'
import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { setDocDrawModalOpen } from '@/client/generalSlice'

export function DocDrawModal({ application }) {
  const dispatch = useAppDispatch()
  const docDrawModalOpen = useAppSelector((state) => state.general.docDrawModalOpen)

  return (
    <Drawer
      title='Workflow / Doc Draw'
      isOpen={docDrawModalOpen}
      setIsOpen={(isOpen) => dispatch(setDocDrawModalOpen(isOpen))}
    >
      <DocDraw application={application} />
    </Drawer>
  )
}
